export default __webpack_public_path__ + "static/media/play.f6fa2f80.svg";